
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiSelectionFrame as ObcPoiSelectionFrameElement} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-selection-frame/poi-selection-frame.js';
 
 
 

 
 export const ObcPoiSelectionFrame = createComponent({
   react: React,
   tagName: 'obc-poi-selection-frame',
   elementClass: ObcPoiSelectionFrameElement,
   events: {
     
   }
  });
 
 